import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const StoreBuildingOutline = createIcon({
  displayName: 'StoreBuildingOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <rect width="24" height="24"></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.5 9.75v0c0 1.24264-1.00736 2.25-2.25 2.25"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 9.75v0c0 1.24264-1.00736 2.25-2.25 2.25 -1.24264 0-2.25-1.00736-2.25-2.25"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16.5 9.75v0c0 1.24264-1.00736 2.25-2.25 2.25 -1.24264 0-2.25-1.00736-2.25-2.25"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18.75 12l-9.83506e-08-1.77636e-15c-1.24264-5.43176e-08-2.25-1.00736-2.25-2.25 0 0 0-1.77636e-15 0-1.77636e-15"
        ></path>
        <line
          x1="20"
          x2="20"
          y1="11.62"
          y2="21"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="22"
          x2="2"
          y1="21"
          y2="21"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="4"
          x2="4"
          y1="11.62"
          y2="21"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <rect
          width="4"
          height="3"
          x="13.5"
          y="15"
          rx=".27614"
          ry="0"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7 21v-5.5l5.32907e-15 7.54979e-08c-4.16963e-08-.276142.223858-.5.5-.5h2.5 -2.18557e-08c.276142-1.20706e-08.5.223858.5.5v5.5"
        ></path>
        <line
          x1="7.5"
          x2="7.5"
          y1="9.75"
          y2="9"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="12"
          x2="12"
          y1="9.75"
          y2="9"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="16.5"
          x2="16.5"
          y1="9.75"
          y2="9"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="20.91"
          x2="3.09"
          y1="9"
          y2="9"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18.75 12v0l-9.83506e-08-1.77636e-15c1.24264 5.43176e-08 2.25-1.00736 2.25-2.25v-.127l4.51835e-08-.000450315c0-.407665-.111053-.807628-.321232-1.15694l-2.1-3.495 7.50707e-08 1.25053e-07c-.360769-.600972-1.00983-.969218-1.71077-.970614h-9.736l-1.75528e-08-1.68754e-13c-.702529-6.75288e-06-1.35355.368588-1.715.971l-2.1 3.495 5.90791e-08-9.90048e-08c-.208707.349752-.31829.749712-.317 1.157v.127l2.4869e-14 3.39741e-07c1.87634e-07 1.24264 1.00736 2.25 2.25 2.25 0 0 1.07015e-09 0 1.07015e-09 0v0"
        ></path>
      </g>
    </>
  ),
})

const StoreBuildingTwoTone = createIcon({
  displayName: 'StoreBuildingTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" color="twoToneStrokeColor" fill="none">
        <rect width="24" height="24"></rect>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7.5 9.75v0c0 1.24264-1.00736 2.25-2.25 2.25"
        ></path>
        <Box
          as="path"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 9.75v0c0 1.24264-1.00736 2.25-2.25 2.25 -1.24264 0-2.25-1.00736-2.25-2.25"
        ></Box>
        <Box
          as="path"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M16.5 9.75v0c0 1.24264-1.00736 2.25-2.25 2.25 -1.24264 0-2.25-1.00736-2.25-2.25"
        ></Box>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18.75 12l-9.83506e-08-1.77636e-15c-1.24264-5.43176e-08-2.25-1.00736-2.25-2.25 0 0 0-1.77636e-15 0-1.77636e-15"
        ></path>
        <line
          x1="20"
          x2="20"
          y1="11.62"
          y2="21"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="22"
          x2="2"
          y1="21"
          y2="21"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="4"
          x2="4"
          y1="11.62"
          y2="21"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <rect
          width="4"
          height="3"
          x="13.5"
          y="15"
          rx=".27614"
          ry="0"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></rect>
        <Box
          as="path"
          fill="twoToneFillColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7 21v-5.5l5.32907e-15 7.54979e-08c-4.16963e-08-.276142.223858-.5.5-.5h2.5 -2.18557e-08c.276142-1.20706e-08.5.223858.5.5v5.5"
        ></Box>
        <line
          x1="7.5"
          x2="7.5"
          y1="9.75"
          y2="9"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="12"
          x2="12"
          y1="9.75"
          y2="9"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="16.5"
          x2="16.5"
          y1="9.75"
          y2="9"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <line
          x1="20.91"
          x2="3.09"
          y1="9"
          y2="9"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        ></line>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M18.75 12v0l-9.83506e-08-1.77636e-15c1.24264 5.43176e-08 2.25-1.00736 2.25-2.25v-.127l4.51835e-08-.000450315c0-.407665-.111053-.807628-.321232-1.15694l-2.1-3.495 7.50707e-08 1.25053e-07c-.360769-.600972-1.00983-.969218-1.71077-.970614h-9.736l-1.75528e-08-1.68754e-13c-.702529-6.75288e-06-1.35355.368588-1.715.971l-2.1 3.495 5.90791e-08-9.90048e-08c-.208707.349752-.31829.749712-.317 1.157v.127l2.4869e-14 3.39741e-07c1.87634e-07 1.24264 1.00736 2.25 2.25 2.25 0 0 1.07015e-09 0 1.07015e-09 0v0"
        ></path>
      </Box>
    </>
  ),
})

const StoreBuilding: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
  case 'twoTone':
    return <CustomIcon as={StoreBuildingTwoTone} {...props} />
  default:
    return <CustomIcon as={StoreBuildingOutline} {...props} />
  }
}

export default memo(StoreBuilding)
